import { PageHeader } from "@/components/module/ModulePrimitives";
import ResourcesSection from "@/components/dashboard/ResourcesSection";

export default function Resources() {
  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow="Enterprise Asset Management"
        title="Company Resources"
        badge="Founder Access"
        description="Track company hardware, inventory, office equipment, and manage assignments across your organization."
      />
      <ResourcesSection />
    </div>
  );
}
